import { BarChart3, CheckCircle, Clock, Shield, TrendingUp, Users } from 'lucide-react'
import React from 'react'

const About = () => {
    return (
        <section id="about" className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl lg:text-4xl font-bold text-[#002047] mb-4">
                        About Smart Dairy
                    </h2>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        See every transaction owner in one place for every type of operational spend.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
                    <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow text-center">
                        <Users className="h-12 w-12 text-[#002047] mx-auto mb-4" />
                        <h3 className="text-xl font-semibold text-[#002047] mb-2">Customer Management</h3>
                        <p className="text-gray-600">Comprehensive CRM to manage all your dairy customers and relationships efficiently.</p>
                    </div>
                    <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow text-center">
                        <BarChart3 className="h-12 w-12 text-[#002047] mx-auto mb-4" />
                        <h3 className="text-xl font-semibold text-[#002047] mb-2">Analytics & Reports</h3>
                        <p className="text-gray-600">Real-time analytics and detailed reports to make data-driven business decisions.</p>
                    </div>
                    <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow text-center">
                        <TrendingUp className="h-12 w-12 text-[#002047] mx-auto mb-4" />
                        <h3 className="text-xl font-semibold text-[#002047] mb-2">Inventory Tracking</h3>
                        <p className="text-gray-600">Track milk production, storage, and distribution with precision and ease.</p>
                    </div>
                    <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow text-center">
                        <Shield className="h-12 w-12 text-[#002047] mx-auto mb-4" />
                        <h3 className="text-xl font-semibold text-[#002047] mb-2">Secure & Reliable</h3>
                        <p className="text-gray-600">Enterprise-grade security ensuring your business data is always protected.</p>
                    </div>
                </div>

                <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-lg">
                    <div className="grid lg:grid-cols-2 gap-12 items-center">
                        <div>
                            <h3 className="text-2xl lg:text-3xl font-bold text-[#002047] mb-6">
                                Why Choose Smart Dairy?
                            </h3>
                            <div className="space-y-4">
                                <div className="flex items-start space-x-3">
                                    <CheckCircle className="h-6 w-6 text-green-500 mt-1" />
                                    <div>
                                        <h4 className="font-semibold text-[#002047]">Industry Expertise</h4>
                                        <p className="text-gray-600">Built specifically for dairy businesses by industry experts who understand your challenges.</p>
                                    </div>
                                </div>
                                <div className="flex items-start space-x-3">
                                    <CheckCircle className="h-6 w-6 text-green-500 mt-1" />
                                    <div>
                                        <h4 className="font-semibold text-[#002047]">Easy Integration</h4>
                                        <p className="text-gray-600">Seamlessly integrate with your existing systems and workflows without disruption.</p>
                                    </div>
                                </div>
                                <div className="flex items-start space-x-3">
                                    <CheckCircle className="h-6 w-6 text-green-500 mt-1" />
                                    <div>
                                        <h4 className="font-semibold text-[#002047]">24/7 Support</h4>
                                        <p className="text-gray-600">Round-the-clock customer support to ensure your operations never stop.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bg-gradient-to-br from-[#002047] to-blue-800 rounded-xl p-8 text-white">
                            <Clock className="h-16 w-16 mb-6" />
                            <h4 className="text-xl font-bold mb-4">Save Time & Increase Efficiency</h4>
                            <p className="text-blue-100">
                                Our customers report an average of 40% increase in operational efficiency and 25% reduction in administrative tasks.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About
